<div class="filter__fields" *ngIf="trip()">
  <mat-card class="mat-elevation-z8">
    <mat-card-content>
      <mat-grid-list [cols]="2" gutterSize="10px" rowHeight="90">
        <mat-grid-tile>
          <read-only-form-field title="Trip ID" [value]="trip()?.id?.toString()" testId="kt-trip-id" />
        </mat-grid-tile>
        <mat-grid-tile>
          <read-only-form-field title="Trip Reference" [value]="trip()?.tripReference" testId="kt-trip-reference" />
        </mat-grid-tile>
        <mat-grid-tile>
          <read-only-form-field title="Client" [value]="trip()?.mainClientName" testId="kt-trip-client" />
        </mat-grid-tile>
        <mat-grid-tile>
          <read-only-form-field title="Client Email" [value]="trip()?.mainClientEmail" testId="kt-trip-client-email" />
        </mat-grid-tile>
        <mat-grid-tile>
          <read-only-form-field title="Agent" [value]="trip()?.agentName" testId="kt-trip-agent" />
        </mat-grid-tile>
        <mat-grid-tile *ngIf="trip()?.commissionAgencyName">
          <read-only-form-field title="Tour Agency" [value]="trip()?.commissionAgencyName" testId="kt-trip-tour-agency" />
        </mat-grid-tile>
        <mat-grid-tile>
          <read-only-form-field title="Booked Date" [value]="trip()?.bookedDate | date:'M/dd/yyyy'" testId="kt-trip-booked-date" />
        </mat-grid-tile>
        <mat-grid-tile>
          <read-only-form-field title="Trip Start Date" [value]="trip()?.tripStartDate | date:'M/dd/yyyy'" testId="kt-trip-start-date" />
        </mat-grid-tile>
        <mat-grid-tile>
          <read-only-form-field title="Number of Days" [value]="trip()?.numberOfDays?.toString()" testId="kt-trip-days" />
        </mat-grid-tile>
        <mat-grid-tile>
          <read-only-form-field title="Status" [value]="trip()?.isCancelled ? 'Cancelled' : 'Active'" testId="kt-trip-status" />
        </mat-grid-tile>
      </mat-grid-list>
    </mat-card-content>
  </mat-card>

  <br>
  <div><h2 class="page-details-title-style">Services</h2></div>
  <app-kt-services-list [salesOrderId]="tripId()"></app-kt-services-list>

  <br>
  <div><h2 class="page-details-title-style">Traveler Payments</h2></div>
  <app-kt-payments-list [salesOrderId]="tripId()"></app-kt-payments-list>

  <br>
  <div><h2 class="page-details-title-style">COGS</h2></div>
  <app-kt-cogs-list [salesOrderId]="tripId()"></app-kt-cogs-list>

  <br>
  <div><h2 class="page-details-title-style">VPO Adjustments</h2></div>
  <app-kt-vpo-adjustments-list [salesOrderId]="tripId()"></app-kt-vpo-adjustments-list>

  <br>
  <div><h2 class="page-details-title-style">History</h2></div>
  <app-kt-trip-history [salesOrderId]="tripId()"></app-kt-trip-history>
</div>
